import api from './axios';

// ============================================
// RESIDENT BOOKING APIs
// ============================================

export const getFacilities = async () => {
  const response = await api.get('/bookings/facilities');
  return response.data;
};

export const getSlots = async (slug, date) => {
  const response = await api.get(`/bookings/facilities/${slug}/slots`, { params: { date } });
  return response.data;
};

export const createBooking = async (data) => {
  const response = await api.post('/bookings', data);
  return response.data;
};

export const getMyBookings = async () => {
  const response = await api.get('/bookings/my');
  return response.data;
};

export const cancelBooking = async (id) => {
  const response = await api.post(`/bookings/${id}/cancel`);
  return response.data;
};

// ============================================
// ADMIN FACILITY MANAGEMENT APIs
// ============================================

export const getAllFacilities = async () => {
  const response = await api.get('/facilities');
  return response.data;
};

export const createFacility = async (data) => {
  const response = await api.post('/facilities', data);
  return response.data;
};

export const getFacilityDetail = async (id) => {
  const response = await api.get(`/facilities/${id}`);
  return response.data;
};

export const updateFacility = async (id, data) => {
  const response = await api.put(`/facilities/${id}`, data);
  return response.data;
};

export const deleteFacility = async (id) => {
  const response = await api.delete(`/facilities/${id}`);
  return response.data;
};

export const toggleFacilityActive = async (id) => {
  const response = await api.post(`/facilities/${id}/toggle-active`);
  return response.data;
};

export const getAllBookings = async (params = {}) => {
  const response = await api.get('/facilities/bookings', { params });
  return response.data;
};

export const adminCancelBooking = async (id) => {
  const response = await api.post(`/facilities/bookings/${id}/cancel`);
  return response.data;
};

export const approveBooking = async (id) => {
  const response = await api.post(`/facilities/bookings/${id}/approve`);
  return response.data;
};

export const blockSlot = async (facilityId, data) => {
  const response = await api.post(`/facilities/${facilityId}/block-slot`, data);
  return response.data;
};

export const unblockSlot = async (id) => {
  const response = await api.delete(`/facilities/blocked-slots/${id}`);
  return response.data;
};

export const getBlockedSlots = async (facilityId) => {
  const response = await api.get(`/facilities/${facilityId}/blocked-slots`);
  return response.data;
};

export const getFacilityStats = async () => {
  const response = await api.get('/facilities/stats');
  return response.data;
};
